module.exports = __webpack_public_path__ + "static/media/india.c530a2a4.jpg";